// Aviso de privacidad simplificado del formulario público de postulación.
// El texto es el que mandó Capital Humano; el enlace lleva al aviso integral.

export const CORREO_CAPITAL_HUMANO = 'capitalhumano@slyrsa.com.mx'
export const RUTA_AVISO_INTEGRAL = '/aviso-de-privacidad'

const AvisoDePrivacidadSimplificado = () => (
  <div className="bg-white/70 border border-gray-200 rounded-lg p-4 mb-8 text-sm text-gray-700 text-left">
    <p className="font-medium text-gray-900 mb-1">Aviso de Privacidad Simplificado</p>
    <p>
      Slyrsa Grupo Industrial, S.A. de C.V. utilizará los datos personales aquí recabados
      (identificación, contacto, laborales y académicos) de forma estrictamente confidencial y
      con la única finalidad de evaluar su postulación e integrarlo a nuestros procesos de
      selección interna de personal. En ningún caso se transferirán estos datos a terceros sin su
      consentimiento. Para conocer los detalles del aviso de privacidad integral o ejercer sus
      derechos ARCO, puede ponerse en contacto con nuestro departamento encargado a través del
      correo electrónico{' '}
      <a href={`mailto:${CORREO_CAPITAL_HUMANO}`} className="text-blue-600 hover:underline">
        {CORREO_CAPITAL_HUMANO}
      </a>{' '}
      o{' '}
      <a
        href={RUTA_AVISO_INTEGRAL}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-600 hover:underline"
      >
        hacer clic aquí para consultar nuestro Aviso de Privacidad Integral
      </a>
      .
    </p>
  </div>
)

export default AvisoDePrivacidadSimplificado
